import React, { useState, useEffect } from "react";

const ShowAddress = ({
  field: { name },
  form: { setFieldValue },
  setAddressState,
  ...props
}) => {
  useEffect(() => { }, [props.id, setAddressState]);

  return (
    <>
      {setAddressState != null &&
        setAddressState != undefined &&
        !(Object.keys(setAddressState).length === 0) ? (
        <div className="display-flex-center flex-wrap">
          <div>
            <span className="address-label">Address</span>
            <span className="address-inputfields"> : {setAddressState?.address ? <>{setAddressState.address}</>
              :
              <>{setAddressState?.raw?.address ? <>{setAddressState.raw.address}</>
                :
                <>{setAddressState?.consignee_address ? <>{setAddressState.consignee_address}</>
                  :
                  <>{setAddressState?.consignor_address ? <>{setAddressState.consignor_address}</> : <>NA</>}</>
                }
                </>
              }
              </>
            }
            </span>
          </div>
          <div className="address-divider">|</div>
          <div>
            <span className="address-label">City</span>
            <span className="address-inputfields"> : {setAddressState.cityName ? <>{setAddressState.cityName}</>
              :
              <>{setAddressState?.raw?.cityName ? <>{setAddressState.raw.cityName}</>
                :
                <>{setAddressState?.consignee_city ? <>{setAddressState.consignee_city}</>
                  :
                  <>{setAddressState?.consignor_city ? <>{setAddressState.consignor_city}</>
                    :
                    <>NA</>
                  }
                  </>
                }
                </>
              }
              </>
            }
            </span>
          </div>
        </div>
      ) : <></>}
    </>
  );
};

export default ShowAddress;
